import React from 'react';
import PropTypes from 'prop-types';
import PageHeader from './PageHeader';

function BasicPage({ title, action, children }) {
  let titleElement;

  if (title) {
    titleElement = <PageHeader title={title} action={action} />;
  }

  return (
    <main className="content">
      <div className="container-fluid">
        {titleElement}
        <div className="row">
          <div className="col-md-12">
            {children}
          </div>
        </div>
      </div>
    </main>
  );
}

BasicPage.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  action: PropTypes.node,
  children: PropTypes.node,
};

BasicPage.defaultProps = {
  title: null,
  action: null,
  children: null,
};

export default BasicPage;
